<template>
    <div>
        <el-dialog v-if="tableShow" v-el-drag-dialog title="文件夹" :visible.sync="tableShow" width="1200px" :close-on-click-modal="false">
            <!-- <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-d-arrow-right">
        <transition-group name="breadcrumb">
          <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.name">
            <span v-if="index===0&&levelList.length>1" style="float:left;cursor: pointer;font-size:16px;margin-right: 10px;" @click="back(levelList[levelList.length-2])"><i class="el-icon-back" /></span>
            <span :key="index" class="no-redirect">{{ item.name }}</span>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb> -->
            <data-table v-if="tableShow" :mode="'dataTable111212'" :class="isShowType === 'fxgwIsFile' || isShowType === 'wscdIsFile' ? 'refresh' : 'isrefresh'" :module-info="moduleInfo" :tb-columns="tableList" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-cell-click="cellclick" :on-selected-rows-change="selectedRowsChange">
                <template slot="toolbarLeft-slotLeft">
                    <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-d-arrow-right">
                        <transition-group name="breadcrumb">
                            <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.name">
                                <span v-if="index === 0 && levelList.length > 1" style="float: left; cursor: pointer; font-size: 20px; margin-right: 10px" @click="back(levelList[levelList.length - 2])"><svg-icon icon-class="wjzx_back" /></span>
                                <span><img :src="'images/w-imgs/email/folder.png'" style="width: 16px; position: relative; top: 2px" alt="" /></span>
                                <span :key="index" style="color: #4a4a4a; font-size: var(--portalFontSize12)" class="no-redirect">{{ item.name }}</span>
                            </el-breadcrumb-item>
                        </transition-group>
                    </el-breadcrumb>
                </template>
            </data-table>
            <Basicform :append-to-body="true" :modal-append-to-body="false" :title="moduleInfoShare.title" :win-width="moduleInfoShare.winWidth" :win-height="moduleInfoShare.winHeight" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit">
                <template #default="slotProps">
                    <FileForm :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfoShare" />
                </template>
            </Basicform>
            <span slot="footer" class="dialog-footer">
                <el-button :icon="'el-icon-close'" @click="tableShow = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
// 分享表单
import FileForm from './FileForm'
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
        FileForm
    },
    props: {
        isShowType: {
            type: String,
            default: function () {
                return ''
            }
        }
    },
    data() {
        return {
            moduleInfo: {
                getByIdUrl: '/disk/file/getById',
                listDataUrl: '',
                addNewUrl: '/disk/file/addNew',
                insertUrl: '/disk/file/insert',
                updateUrl: '/disk/file/update',
                uploadUrl: '/disk/file/upload',
                downloadUrl: '/disk/file/downloadById',
                delUrl: '/disk/file/delete',
                winWidth: 1200, // 查看、编辑窗口宽度
                winHeight: 650 // 查看、编辑窗口高度
            },
            moduleInfoShare: {
                title: '分享',
                getByIdUrl: '/disk/share/getById',
                listDataUrl: '/disk/share/listdata',
                addNewUrl: '/disk/share/addNew',
                insertUrl: '/disk/share/insert',
                updateUrl: '/disk/share/update',
                uploadUrl: '/disk/share/upload',
                delUrl: '/disk/share/delete',
                winWidth: 1200, // 查看、编辑窗口宽度
                winHeight: 650 // 查看、编辑窗口高度
            },
            type: 0,
            tableList: [
                {
                    field: 'state',
                    checkbox: true,
                    width: '45px'
                },
                {
                    field: 'index',
                    title: '序号',
                    width: '45px',
                    align: 'center',
                    valign: 'middle'
                },
                {
                    propFormatter: 'component：@/wapp/wjzx/components/WjzxComponentTbColumns',
                    field: 'name',
                    title: '文件名称',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 0
                },
                {
                    field: 'actualSize',
                    title: '文件大小',
                    width: '110px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: true,
                    searchable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 3,
                    elementFormatter: ''
                },
                {
                    field: 'createName',
                    title: '创建人',
                    width: '100px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: true,
                    searchable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 3,
                    elementFormatter: ''
                },
                {
                    field: 'createDate',
                    title: '创建时间',
                    width: '130px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: true,
                    listAdvSearchElement: 'date',
                    elementFormatter: 'format：yyyy-MM-dd HH:mm\r\n',
                    listAdvSearchIndex: 4
                }
            ],
            listpageBtns: [],
            dialogFormVisible: false,
            tableShow: false,
            row: {},
            levelList: [],
            backurl: '',
            rowsSelected: [], // 批量选择
            shareType: 'all',
            loginUser: this.$store.getters.loginUser
        }
    },
    computed: {
        ...mapGetters(['routes', 'sidebar'])
    },
    // 监控data中的数据变化
    watch: {
        tableShow(val) {
            if (!val) {
                this.levelList = []
                this.rowsSelected = []
            }
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log(this.isShowType, '操作列显示及操作按钮定义')
        this.tableList[2].propFormatter = 'component：@/wapp/wjzx/components/WjzxComponentTbColumns'
        if (this.isShowType === 'wfxdOffFile') {
            // 我分享的已过期和分享记录
            return
        } else if (this.isShowType === 'wfxdIsFile') {
            // 我分享的可查阅
            return
        } else if (this.isShowType === 'fxgwIsFile') {
            // 分享给我可查阅
            this.tableList.push({ propFormatter: 'function：operateFormatter', listAdvSearchElement: '', field: 'state', width: '100px', sortable: false, propType: 'String', align: 'center', title: '操作', searchable: false })
            this.listpageBtns = [
                { btnName: '收藏', btnIcon: '', btnClick: this.cancel, btnPermission: 'undo', id: 'btn_edit', btnType: 'column' },
                { btnName: '下载', btnIcon: '', btnClick: this.download, btnPermission: 'undo', id: 'btn_edit', btnType: 'column' },
                { btnName: '分享', btnIcon: '', btnClick: this.share, btnPermission: 'undo', id: 'btn_edit', btnType: 'column' }
            ]
            this.listpageBtns = [
                ...this.listpageBtns,
                ...[
                    { btnName: '收藏', btnIcon: 'wjzx_shoucang.svg', btnClick: this.collection, btnPermission: 'allCollection', id: 'btn_add', btnType: 'toolbar' },
                    { btnName: '下载', btnIcon: 'wjzx_downcopy.svg', btnClick: this.allDownload, btnPermission: 'allDownload', id: 'btn_deleteIds', btnType: 'toolbar' },
                    { btnName: '分享', btnIcon: 'wjzx_fenxaing.svg', btnClick: this.allShare, btnPermission: 'allShare', id: 'btn_edit', btnType: 'toolbar' },
                    { btnName: '转发邮件', btnIcon: 'wjzx_forwarding.svg', btnClick: this.writeMail, btnPermission: 'writeMail', id: 'btn_deleteId', btnType: 'toolbar' }
                ]
            ]
        } else if (this.isShowType === 'fxgwOffFile') {
            // 分享给我已过期-不可下载及打开文件夹后也不可下载
            this.tableList[2].propFormatter = 'component：@/wapp/wjzx/components/WjzxComponentNotClickTbColumns'
            return
        } else if (this.isShowType === 'wscdIsFile') {
            // 我收藏的可查阅
            this.tableList.push({ propFormatter: 'function：operateFormatter', listAdvSearchElement: '', field: 'state', width: '100px', sortable: false, propType: 'String', align: 'center', title: '操作', searchable: false })
            this.listpageBtns = [
                { btnName: '取消收藏', btnIcon: '', btnClick: this.qxCancel, btnPermission: 'undo', id: 'btn_edit', btnType: 'column' },
                { btnName: '下载', btnIcon: '', btnClick: this.download, btnPermission: 'undo', id: 'btn_edit', btnType: 'column' },
                { btnName: '分享', btnIcon: '', btnClick: this.share, btnPermission: 'undo', id: 'btn_edit', btnType: 'column' }
            ]
            this.listpageBtns = [
                ...this.listpageBtns,
                ...[
                    { btnName: '收藏', btnIcon: 'wjzx_shoucang.svg', btnClick: this.collection, btnPermission: 'allCancel', id: 'btn_add', btnType: 'toolbar' },
                    { btnName: '下载', btnIcon: 'wjzx_downcopy.svg', btnClick: this.allDownload, btnPermission: 'download', id: 'btn_deleteIds', btnType: 'toolbar' },
                    { btnName: '分享', btnIcon: 'wjzx_fenxaing.svg', btnClick: this.allShare, btnPermission: 'allShare', id: 'btn_deleteIds', btnType: 'toolbar' }
                ]
            ]
        } else if (this.isShowType === 'wscdOffFile') {
            // 我收藏的已过期-不可下载及打开文件夹后也不可下载
            this.tableList[2].propFormatter = 'component：@/wapp/wjzx/components/WjzxComponentNotClickTbColumns'
            return
        }
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$bus.$on('openBounced', this.setListDataUrl)
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
        this.$bus.$off('openBounced', this.setListDataUrl)
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {
        selectedRowsChange(rows) {
            this.rowsSelected = rows
        },
        // render函数动态渲染图标
        operateFormatter(h, row, column, cellValue, index) {
            var _this = this
            if (row.passenger.isCollect === '0') {
                return h('span', [
                    h(
                        'a',
                        {
                            attrs: {
                                title: '收藏'
                            },
                            class: 'el-link el-link--default is-underline',
                            on: {
                                click: function () {
                                    _this.cancel(row)
                                }
                            }
                        },
                        [
                            h(
                                'span',
                                {
                                    class: 'el-link--inner'
                                },
                                [
                                    h('svg-icon', {
                                        attrs: {
                                            'icon-class': 'fiveStar'
                                        }
                                    })
                                ]
                            )
                        ]
                    ),
                    h(
                        'a',
                        {
                            attrs: {
                                title: '下载'
                            },
                            class: 'el-link el-link--default is-underline',
                            on: {
                                click: function () {
                                    _this.download(row)
                                }
                            }
                        },
                        [
                            h(
                                'span',
                                {
                                    class: 'el-link--inner'
                                },
                                [
                                    h('svg-icon', {
                                        attrs: {
                                            'icon-class': 'wjzx_down'
                                        }
                                    })
                                ]
                            )
                        ]
                    ),
                    h(
                        'a',
                        {
                            attrs: {
                                title: '分享'
                            },
                            class: 'el-link el-link--default is-underline',
                            on: {
                                click: function () {
                                    _this.share(row)
                                }
                            }
                        },
                        [
                            h(
                                'span',
                                {
                                    class: 'el-link--inner'
                                },
                                [
                                    h('svg-icon', {
                                        attrs: {
                                            'icon-class': 'wjzx_fenxaing_m'
                                        }
                                    })
                                ]
                            )
                        ]
                    )
                ])
            } else {
                return h('span', [
                    h(
                        'a',
                        {
                            attrs: {
                                title: '取消收藏'
                            },
                            class: 'el-link el-link--default is-underline',
                            on: {
                                click: function () {
                                    _this.qxCancel(row)
                                }
                            }
                        },
                        [
                            h(
                                'span',
                                {
                                    class: 'el-link--inner'
                                },
                                [
                                    h('svg-icon', {
                                        attrs: {
                                            'icon-class': 'fiveStar3'
                                        }
                                    })
                                ]
                            )
                        ]
                    ),
                    h(
                        'a',
                        {
                            attrs: {
                                title: '下载'
                            },
                            class: 'el-link el-link--default is-underline',
                            on: {
                                click: function () {
                                    _this.download(row)
                                }
                            }
                        },
                        [
                            h(
                                'span',
                                {
                                    class: 'el-link--inner'
                                },
                                [
                                    h('svg-icon', {
                                        attrs: {
                                            'icon-class': 'wjzx_down'
                                        }
                                    })
                                ]
                            )
                        ]
                    ),
                    h(
                        'a',
                        {
                            attrs: {
                                title: '分享'
                            },
                            class: 'el-link el-link--default is-underline',
                            on: {
                                click: function () {
                                    _this.share(row)
                                }
                            }
                        },
                        [
                            h(
                                'span',
                                {
                                    class: 'el-link--inner'
                                },
                                [
                                    h('svg-icon', {
                                        attrs: {
                                            'icon-class': 'wjzx_fenxaing_m'
                                        }
                                    })
                                ]
                            )
                        ]
                    )
                ])
            }
        },
        // 单个收藏
        cancel: function (row) {
            var list = []
            list.push({
                fileId: row.id,
                fileType: row.resoureType, // 2文件 //1文件夹
                fileSource: 0 // 0分享文件 1非分享文件
            })
            this.$confirm('确认要收藏选中的文件吗？', '确认操作', { type: 'warning' })
                .then(() => {
                    this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        data: list,
                        url: '/disk/collect/insert'
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            // 刷新列表
                            this.$bus.$emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        // 批量收藏
        collection(val) {
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择要收藏的文件!', '操作提示', { type: 'warning' })
                return
            }
            var list = []
            this.rowsSelected.map((res) => {
                list.push({
                    fileId: res.id,
                    fileType: res.resoureType, // 2文件 //1文件夹
                    fileSource: 1 // 0分享文件 1非分享文件
                })
            })
            this.$confirm('确认要收藏选中的文件吗？', '确认操作', { type: 'warning' })
                .then(() => {
                    this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        data: list,
                        url: '/disk/collect/insert'
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            // 刷新列表
                            this.$bus.$emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        // 单个取消收藏
        qxCancel: function (row) {
            this.$confirm('确认取消该收藏文件吗？', '确认操作', { type: 'warning' })
                .then(() => {
                    const params = {
                        ids: row.id,
                        status: 0
                    }
                    this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        params: params,
                        url: '/disk/vwcollectfile/updateCollect'
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            // 刷新列表
                            this.$bus.$emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        // 单个分享
        share(row) {
            this.shareType = 'one'
            var list = []
            list.push(row)
            // for (let index = 0; index < list.length; index++) {
            //     const element = list[index]
            //     element.id = element.fileId
            // }
            this.moduleInfoShare.shareList = list
            this.moduleInfoShare.isShow = true
            this.moduleInfoShare.number = this.row.passenger.number
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfoShare, null, 1)
            })
        },
        // 批量分享文件
        allShare() {
            this.shareType = 'all'
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择要分享的文件!', '操作提示', { type: 'warning' })
                return
            }
            this.moduleInfoShare.shareList = this.rowsSelected
            this.moduleInfoShare.isShow = true
            // this.moduleInfoShare.number = this.row.passenger.number
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfoShare, null, 1)
            })
        },
        // 操作列下载附件
        download(row) {
            if (!row.id) return
            if (row.name.indexOf('.ofd') > -1) {
                let downUrl = process.env.VUE_APP_BASE_API + '/' + this.moduleInfo.downloadUrl + '?inline=false&attachIds=' + row.id + '&fileName=' + row.name + '&saveAs=' + row.name
                window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
            } else {
                window.open(process.env.VUE_APP_BASE_API + '/' + `${this.moduleInfo.downloadUrl}?inline=false&attachIds=` + row.id + '&saveAs=' + row.name)
            }
        },
        // 批量下载附件
        allDownload() {
            if (this.rowsSelected.length > 0) {
                let ids = ''
                this.rowsSelected.forEach((res) => {
                    if (ids !== '') {
                        ids += ','
                    }
                    ids += res.id
                })
                window.open(process.env.VUE_APP_BASE_API + '/' + `${this.moduleInfo.downloadUrl}?inline=false&attachIds=` + ids + '&saveAs=' + (this.rowsSelected.length > 1 ? (this.rowsSelected[0].name.indexOf('.') !== -1 ? this.rowsSelected[0].name.split('.')[0] : this.rowsSelected[0].name) : this.rowsSelected[0].name))
            } else {
                this.$alert('请选择要下载的文件!', '操作提示', { type: 'warning' })
            }
        },
        // 操作列撤销
        undo(row) {
            var _this = this
            this.$confirm('确认要撤销该文件吗？', '确认操作', { type: 'warning' })
                .then(function () {
                    const params = {
                        ids: _this.row.shareId
                    }
                    _this
                        .$http({
                            method: 'POST',
                            contentType: 'application/x-www-form-urlencoded',
                            params: params,
                            url: '/disk/vwsharefile/updateUndo'
                        })
                        .then((res) => {
                            if (res.code === 'success') {
                                _this.$message.success(res.message)
                                // 刷新列表
                                // _this.$bus.$emit('refreshListData')
                                _this.setListDataUrl()
                            } else {
                                _this.$message.error(res.message)
                            }
                        })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        // 权限控制
        permissionsControl() {
            var list = [
                {
                    btnName: '下载',
                    btnIcon: 'wjzx_down.svg',
                    btnClick: this.allDownload,
                    btnPermission: '',
                    id: 'btn_add',
                    btnType: 'toolbar'
                },
                {
                    btnName: '删除',
                    btnIcon: 'wjzx_del.svg',
                    btnClick: 'deleteIds();',
                    btnPermission: '',
                    id: 'btn_deleteIds',
                    btnType: 'toolbar'
                },
                {
                    btnName: '收藏',
                    btnIcon: 'wjzx_shoucang.svg',
                    btnClick: this.collection,
                    btnPermission: '',
                    id: 'btn_deleteIds',
                    btnType: 'toolbar'
                },
                {
                    id: 'btn_seetingId',
                    btnName: '移动',
                    btnIcon: 'wjzx_mobile.svg',
                    btnClick: this.mobile,
                    btnPermission: 'setting',
                    btnType: 'toolbar'
                },
                {
                    btnName: '分享',
                    btnIcon: 'wjzx_fenxaing.svg',
                    btnClick: this.allShare,
                    btnPermission: '',
                    id: 'btn_download',
                    btnType: 'toolbar'
                },
                {
                    btnName: '转发邮件',
                    btnIcon: 'wjzx_forwarding.svg',
                    btnClick: this.writeMail,
                    btnPermission: '',
                    id: 'btn_download',
                    btnType: 'toolbar'
                },
                {
                    id: 'btn_edit',
                    btnName: '分享记录',
                    btnIcon: 'wjzx_sharejl.svg',
                    btnClick: this.shareRecord,
                    btnPermission: 'editObject',
                    btnType: 'column'
                },
                {
                    id: 'btn_deleteId',
                    btnName: '下载',
                    btnIcon: 'wjzx_down.svg',
                    btnClick: this.download,
                    btnPermission: 'setting',
                    btnType: 'column'
                },
                {
                    id: 'btn_edit',
                    btnName: '编辑',
                    btnIcon: 'wjzx_edit.svg',
                    btnClick: this.editObjectFile,
                    btnPermission: 'editObject',
                    btnType: 'column'
                },
                {
                    id: 'btn_deleteId',
                    btnName: '删除',
                    btnIcon: 'wjzx_del.svg',
                    btnClick: 'deleteIds(row.id);',
                    btnPermission: 'deleteIds',
                    btnType: 'column'
                }
            ]
            if (this.type === 0) {
                this.listpageBtns = list
                return
            }
            this.$store.state.user.roles.forEach((res) => {
                if (res === 'wjzxDeptMgr') {
                    // 部门文件管理员
                    this.wjzxDeptMgr = true
                } else if (res === 'wjzxCompanyMgr') {
                    // 单位文件管理员
                    this.wjzxCompanyMgr = true
                }
            })
            if ((this.wjzxDeptMgr && this.type === 1) || (this.wjzxCompanyMgr && this.type === 2)) {
                this.listpageBtns = list
            }
        },
        // 请求接口前先判断是个人,部门,公司
        async isBeforeOpenSetListDataUrl() {
            const { staffList, personId, orgCode } = { ...this.$store.getters.loginUser }
            if (this.type === 0) {
                // 个人
                var accountId = ''
                await this.$http({
                    method: 'GET',
                    url: '/disk/account/getByPersonId',
                    params: { personId: personId }
                }).then((resp) => {
                    if (resp.code === 'success') {
                        accountId = resp.body.accountId
                    } else {
                        this.$message.error(resp.message)
                        accountId = ''
                    }
                })
                return `;accountId:${accountId}`
            } else if (this.type === 1) {
                // 部门
                let str = ''
                staffList.forEach((res) => {
                    if (str) {
                        str += ',' + res.orgFullId.split('-')[1]
                    } else {
                        str += res.orgFullId.split('-')[1]
                    }
                })
                return `;deptId:${str}`
            } else if (this.type === 2) {
                // 公司
                return `;orgCode:${orgCode}`
            }
        },
        // 后退
        back(row) {
            this.setListDataUrl(row.id, row.row, true)
        },
        // 请求接口
        async setListDataUrl(id, row, type) {
            const { staffList, personId, orgCode } = { ...this.loginUser }
            this.row = row
            // this.isBeforeOpenSetListDataUrl().then(res => {
            let listDataUrl = ''
            if (id) {
                listDataUrl = '/disk/vwfilefolder/listdata?urlsearch=status!:2;orgCode:' + orgCode + ';folderId:' + id
            } else {
                if (this.searchType === '0') {
                    if (this.treeNode.id === '0') {
                        listDataUrl = '/disk/vwfilefolder/listdata?urlsearch=status!:2;orgCode:' + orgCode + '' // 全部
                    } else {
                        listDataUrl = '/disk/vwfilefolder/listdata?urlsearch=status!:2;orgCode:' + orgCode + ';folderId:' + this.treeNode.id
                    }
                } else if (this.searchType === '1') {
                    listDataUrl = '/disk/vwfilefolder/listdata?urlsearch=status!:2;orgCode:' + orgCode + ';type:' + this.flieType
                }
            }
            // listDataUrl += res
            this.tableShow = false
            this.$set(this.moduleInfo, 'listDataUrl', listDataUrl)
            // 列表文件夹路径
            if (!type) {
                this.levelList.push({
                    name: row.fileName ? row.fileName : row.name,
                    row: row,
                    id: id
                })
            } else {
                this.levelList.splice(this.levelList.length - 1, 1)
            }
            this.tableShow = true
            // })
        },
        // 转发邮件
        writeMail() {
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择要转发的文件!', '操作提示', { type: 'warning' })
                return
            }
            try {
                this.rowsSelected.forEach((res) => {
                    if (Number(res.resoureType) === 1) {
                        this.$alert('文件夹不可转发,请重新选择!', '操作提示', { type: 'warning' })
                        throw new Error(true)
                    }
                })
            } catch (e) {
                return
            }
            // this.gotoPages('email.svg', '1')
            var list = []
            var rowsSelected = [...this.rowsSelected]
            rowsSelected.forEach((res) => {
                list.push({
                    busiDataId: '',
                    fileName: res.name,
                    fileMd5: null,
                    filePath: res.path,
                    fileRealSize: 999,
                    fileSize: res.size,
                    fileSort: 1,
                    fileType: 'ATTACH',
                    id: '',
                    onlineFile: null,
                    orgCode: this.loginUser.orgCode,
                    orgName: this.loginUser.orgName,
                    originalName: res.originalName,
                    updateBy: res.createName,
                    updateTime: res.createDate,
                    uploadBy: res.createName,
                    uploadTime: res.createDate
                })
            })
            window.open('/#/sendmail?row=' + JSON.stringify(list) + '&srcBusiDataId=文件中心')
        },
        // 路由跳转
        gotoPages(code) {
            const toPath = this.getMenuCode(code)
            if (toPath && toPath.path) {
                let path
                switch (toPath.meta.level) {
                    case 3:
                        path = toPath.meta.activeMenu || toPath.path
                        break
                    case 4:
                        path = toPath.meta.activeMenu + '/' + toPath.path
                        break
                    default:
                        path = toPath.path
                }
                var list = []
                var rowsSelected = [...this.rowsSelected]
                rowsSelected.forEach((res) => {
                    list.push({
                        busiDataId: '',
                        fileName: res.name,
                        fileMd5: null,
                        filePath: res.path,
                        fileRealSize: 999,
                        fileSize: res.size,
                        fileSort: 1,
                        fileType: 'ATTACH',
                        id: res.id,
                        onlineFile: null,
                        orgCode: this.$store.getters.loginUser.orgCode,
                        orgName: this.$store.getters.loginUser.orgName,
                        originalName: res.originalName,
                        updateBy: res.createName,
                        updateTime: res.createDate,
                        uploadBy: res.createName,
                        uploadTime: res.createDate
                    })
                })
                this.$router.push({ path: path, query: { rowsSelected: list } })
            }
        },
        // 递归查询菜单代码
        getMenuCode(code) {
            let toPath
            function findCode(ary) {
                ary.forEach((val) => {
                    if (val.children) {
                        findCode(val.children)
                    }
                    if (!val.children && val.meta && val.meta.code === code) {
                        toPath = val
                        return false
                    }
                })
            }
            findCode(this.routes)
            return toPath
        },
        onBasicFormBeforeOpen($scope, vo, defer) {
            if (vo.isnew) {
                var text = ''
                var id = ''
                if (this.shareType === 'all') {
                    this.rowsSelected.map((res) => {
                        if (text) text += '、' + res.name
                        if (id) id += ',' + res.id
                        if (!text) text += res.name
                        if (!id) id += res.id
                    })
                } else {
                    text = $scope.moduleInfo.shareList[0].name
                    id = $scope.moduleInfo.shareList[0].id
                }
                vo.passenger.list = $scope.moduleInfo.shareList
                vo.resourceName = text
                vo.resourceId = id
                vo.shareScope = 1
                vo.sharePeriod = 0
                vo.resourceType = 2
            }
            defer.resolve(true)
        },
        onBasicFormOpened($scope, vo) {},
        onBasicFormBeforeSubmit($scope, vo, defer) {
            defer.resolve(true)
        },
        onListDataBeforeLoad($scope, qparams) {
            if (!qparams.orderBy) {
                qparams.orderBy = 'resoureType asc,createDate desc'
            }
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded: function ($scope, pageInfo) {
            for (let i = 0; i < pageInfo.list.length; i++) {
                const nowTime = pageInfo.list[i]
                if (Number(nowTime.resoureType) === 2) {
                    nowTime.actualSize = this.conver(Number(nowTime.actualSize))
                } else {
                    nowTime.actualSize = ''
                }
            }
            console.log('vwreaderfile listdata loaded')
        },
        // 转换大小加单位
        conver(limit) {
            var size = ''
            if (limit < 0.1 * 1024) {
                // 如果小于0.1KB转化成B
                size = limit.toFixed(2) + 'B'
            } else if (limit < 0.1 * 1024 * 1024) {
                // 如果小于0.1MB转化成KB
                size = (limit / 1024).toFixed(2) + 'KB'
            } else if (limit < 0.1 * 1024 * 1024 * 1024) {
                // 如果小于0.1GB转化成MB
                size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
            } else {
                // 其他转化成GB
                size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
            }

            var sizestr = size + ''
            var len = sizestr.indexOf('.')
            var dec = sizestr.substr(len + 1, 2)
            if (dec === '00') {
                // 当小数点后为00时 去掉小数部分
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
            }
            return sizestr
        },
        cellclick(row) {
            if (!row.id || this.isShowType === 'wscdOffFile' || this.isShowType === 'fxgwOffFile') return
            if (row.name.indexOf('.ofd') > -1) {
                let downUrl = process.env.VUE_APP_BASE_API + '/' + this.moduleInfo.downloadUrl + '?inline=true&attachIds=' + row.id + '&fileName=' + row.name + '&saveAs=' + row.name
                window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
            } else {
                window.open(process.env.VUE_APP_BASE_API + '/' + `${this.moduleInfo.downloadUrl}?inline=true&attachIds=` + row.id + '&saveAs=' + row.name)
            }
        }
    } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
// @import url(); 引入公共css类
/deep/.isrefresh {
    .el-table-toolbar-right,
    .el-radio-group {
        display: none;
    }
}
/deep/.refresh .el-radio-group {
    display: none;
}
/deep/.el-table-toolbar-right {
    width: 35%;
}
/deep/.el-table-toolbar-left {
    width: 65%;
}
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: var(--portalFontSize14);
    line-height: 36px;

    .no-redirect {
        color: #909399;
        cursor: text;
    }

    /* .el-breadcrumb__item:last-child .no-redirect{
    color:#409eff;
  } */
    /deep/.el-breadcrumb__item:last-child .el-breadcrumb__separator {
        display: none;
    }
    /deep/.el-breadcrumb__item {
        display: flex;
        align-items: center;
    }
}
/deep/.el-table-toolbar-right {
    width: 40% !important;
}
/deep/ .el-table-toolbar-left {
    width: 60% !important;
}
</style>
